"use strict";
exports.__esModule = true;
exports.cleanPostURLFromIframe = void 0;
var tslib_1 = require("tslib");
var FormField_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/FormField"));
var Grid_1 = tslib_1.__importStar(require("@sportnet/ui/lib/Grid"));
var Segment_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Segment"));
var React = tslib_1.__importStar(require("react"));
var utilities_1 = require("../../../../../utilities/utilities");
var decomposeUrl = function (url) {
    var type = undefined;
    var matchPost = url.match(/^https:\/\/www\.facebook\.com\/(photo(\.php|s)|permalink\.php|media|questions|notes|[^/]+\/(activity|posts))[/?].*$/gm);
    if (matchPost) {
        type = 'post';
    }
    else {
        var matchVideo = url.match(/^https:\/\/www\.facebook\.com\/([^/?].+\/)?video(s|\.php)[/?].*$/gm);
        if (matchVideo) {
            type = 'video';
        }
    }
    if (!type) {
        return {};
    }
    return {
        data_href: url,
        data_type: type,
        data_show_text: type === 'post' ? true : void 0
    };
};
/**
 * Potrebujeme odstranit &show_text=false&width=500 (POZOR: nie su to query parametre, pretoze nie su oddelene `?`.)
 * @param iframe
 */
exports.cleanPostURLFromIframe = function (iframe) {
    var splitted = iframe.split('&');
    return splitted[0];
};
var decomposeEmbedToUrl = function (embed) {
    // <div class="fb-video" data-href="https://www.facebook.com/facebook/videos/10153231379946729/" data-width="500" data-show-text="false"><blockquote cite="https://developers.facebook.com/facebookapp/videos/10153231379946729/" class="fb-xfbml-parse-ignore"><a href="https://developers.facebook.com/facebookapp/videos/10153231379946729/">How to Share With Just Friends</a><p>How to share with just friends.</p>Uverejnil používateľ <a href="https://www.facebook.com/facebookapp/">Facebook App</a> Piatok 5. decembra 2014</blockquote></div>
    var match = embed.match(/(class="fb-)(video|post)(")([a-zA-Z0-9=\-+':&#;/.;" ]*)( data-href=")([-a-zA-Z0-9@:%_+./;~#?&//=]+)(")/);
    if (match) {
        return match[6];
    }
    // <iframe src="https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Fsme.sk%2Fvideos%2F10155193695983642%2F&show_text=0&width=400" width="400" height="400" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allowFullScreen="true"></iframe>
    // /(\/\/www.facebook.com\/plugins\/)(video|post)(.php\?href=)([-a-zA-Z0-9@:%_\+.\/;~#?&//=]+)(")/,
    match = embed.match(/(\/\/www.facebook.com\/plugins\/)(video|post)(.php\?)/);
    if (match) {
        match = embed.match(/(href=)([-a-zA-Z0-9@:%_+./;~#?&//=]+)(")/);
        if (match) {
            return exports.cleanPostURLFromIframe(decodeURIComponent(match[2]));
        }
    }
    // https://www.facebook.com/facebook/videos/10153231379946729/
    match = embed.match(/(facebook.)([a-z]{2,3})(\/)([a-zA-Z0-9.-_]+)\/(posts|videos)\/([0-9]{5,25})/);
    if (match) {
        return embed.trim();
    }
    return '';
};
var Facebook = function (_a) {
    var onChange = _a.onChange, _b = _a.data, data = _b === void 0 ? {} : _b, active = _a.active;
    var _c = React.useState(''), embed = _c[0], setEmbed = _c[1];
    React.useEffect(function () {
        if (active) {
            setEmbed('');
        }
    }, [active]);
    function handleChangeInputValue(e) {
        var _a;
        var _b = e.target, name = _b.name, value = _b.value;
        onChange(tslib_1.__assign(tslib_1.__assign({}, data), (_a = {}, _a[name] = value, _a)));
    }
    function handleChangeCheckbox(e) {
        var _a;
        var _b = e.target, name = _b.name, checked = _b.checked;
        onChange(tslib_1.__assign(tslib_1.__assign({}, data), (_a = {}, _a[name] = checked, _a)));
    }
    var handleChangeEmbed = function (e) {
        var value = e.target.value;
        setEmbed(value);
        var url = decomposeEmbedToUrl(value);
        onChange(decomposeUrl(url));
    };
    var handleChangeUrl = function (e) {
        var value = e.target.value;
        onChange(tslib_1.__assign(tslib_1.__assign({}, decomposeUrl(value)), { data_href: value }));
    };
    var type = data.data_type;
    return (React.createElement(Segment_1["default"], { secondary: true },
        React.createElement(FormField_1["default"], { type: "textarea", name: "facebook_embed", placeholder: utilities_1.__('Vložte vygenerovaný embed kód, alebo URL'), value: embed, onChange: handleChangeEmbed, rows: 7 }),
        React.createElement(Grid_1.Row, null,
            React.createElement(Grid_1["default"], { m: 10 },
                React.createElement(FormField_1["default"], { type: "text", label: "URL", name: "data_href", value: data.data_href || '', onChange: handleChangeUrl, required: true })),
            React.createElement(Grid_1["default"], { m: 2 },
                React.createElement(FormField_1["default"], { type: "text", label: utilities_1.__('Šírka'), name: "data_width", value: data.data_width || '', onChange: handleChangeInputValue }))),
        (type === 'post' || type === 'video') && (React.createElement(FormField_1["default"], { name: "data_show_text", onChange: handleChangeCheckbox, type: "checkbox", label: utilities_1.__('Zobraziť celý príspevok'), checked: data.data_show_text || false, value: data.data_show_text || false }))));
};
exports["default"] = React.memo(Facebook);
